  
<div class="signup-container">
  <div class="signup-container-card">
    <a routerLink="/">
      <img class="signup-container-card--logo" src="assets\logos\logo-projeto.svg">
    </a>
    
    <div class="signup-container-card--select-profile">
      <label>
        <input name="group1" type="radio" (change)="handleShowPersonForm()" checked/>
        <span>Pessoa comum</span>
      </label>
      <label>
        <input name="group1" type="radio" (change)="handleShowCompanyForm()" />
        <span>Empresa</span>
      </label>
    </div>

    <div *ngIf="showPersonForm">
      <form class="signup-container-card--form" #personForm="ngForm" (ngSubmit)="handlePersonForm()">
        <div class="signup-container-card--form-input">
          <label for="personName">Nome:</label>
          <input type="text" personName id="personName" name="personName" [(ngModel)]="signUpPersonForm.name" #personName="ngModel" class="form-control" placeholder="Digite o seu nome" required>
  
          <div class="signup-container-card--form-input-error" *ngIf="personName.invalid && (personName.dirty || personName.touched)">
            <mat-error *ngIf="personName.errors?.['required']">Este campo é obrigatório</mat-error>
          </div>
        </div>

        <div class="signup-container-card--form-input-group">
          <div class="signup-container-card--form-input">
            <label for="cpf">CPF:</label>
            <input type="text" cpf id="cpf" name="cpf" [(ngModel)]="signUpPersonForm.cpf" #cpf="ngModel" class="form-control" placeholder="Digite o seu CPF" mask="000.000.000-00" minlength="11" required>
    
            <div class="signup-container-card--form-input-error" *ngIf="cpf.invalid && (cpf.dirty || cpf.touched)">
              <mat-error *ngIf="cpf.errors?.['required']">Este campo é obrigatório</mat-error>
              <mat-error *ngIf="cpf.errors?.['minlength']">Este campo deve ter 11 digitos</mat-error>
            </div>
          </div>
          
          <div class="signup-container-card--form-input">
            <label for="personPhone">Telefone:</label>
            <input type="text" personPhone id="personPhone" name="personPhone" [(ngModel)]="signUpPersonForm.phone" #personPhone="ngModel" class="form-control" placeholder="Digite o seu telefone" mask="(00) 00000-0000" minlength="11" required>
    
            <div class="signup-container-card--form-input-error" *ngIf="personPhone.invalid && (personPhone.dirty || personPhone.touched)">
              <mat-error *ngIf="personPhone.errors?.['required']">Este campo é obrigatório</mat-error>
              <mat-error *ngIf="personPhone.errors?.['minlength']">Este campo deve ter 11 digitos</mat-error>
            </div>
          </div>
        </div>

        <div class="signup-container-card--form-input">
          <label for="personAddress">Endereco:</label>
          <input type="text" personAddress id="personAddress" name="personAddress" [(ngModel)]="signUpPersonForm.address" #personAddress="ngModel" class="form-control" placeholder="Digite o seu endereço" required>
  
          <div class="signup-container-card--form-input-error" *ngIf="personAddress.invalid && (personAddress.dirty || personAddress.touched)">
            <mat-error *ngIf="personAddress.errors?.['required']">Este campo é obrigatório</mat-error>
          </div>
        </div>

        <div class="signup-container-card--form-input-group">
          <div class="signup-container-card--form-input">
            <label for="personCity">Cidade:</label>
            <input type="text" personCity id="personCity" name="personCity" [(ngModel)]="signUpPersonForm.city" #personCity="ngModel" class="form-control" placeholder="Digite a sua cidade" required>
    
            <div class="signup-container-card--form-input-error" *ngIf="personCity.invalid && (personCity.dirty || personCity.touched)">
              <mat-error *ngIf="personCity.errors?.['required']">Este campo é obrigatório</mat-error>
            </div>
          </div>

          <div class="signup-container-card--form-input">
            <label for="personState">Estado:</label>
            <input type="text" personState id="personState" name="personState" [(ngModel)]="signUpPersonForm.state" #personState="ngModel" class="form-control" placeholder="Digite a sua cidade" required>
    
            <div class="signup-container-card--form-input-error" *ngIf="personState.invalid && (personState.dirty || personState.touched)">
              <mat-error *ngIf="personState.errors?.['required']">Este campo é obrigatório</mat-error>
            </div>
          </div>
        </div>

        <div class="signup-container-card--form-input-group">
          <div class="signup-container-card--form-input">
            <label for="personEmail">Email:</label>
            <input type="email" personEmail id="personEmail" name="personEmail" [(ngModel)]="signUpPersonForm.email" #personEmail="ngModel" class="form-control" placeholder="Digite o seu e-mail" required>
    
            <div class="signup-container-card--form-input-error" *ngIf="personEmail.invalid && (personEmail.dirty || personEmail.touched)">
              <mat-error *ngIf="personEmail.invalid">Digite o e-mail no formato correto</mat-error>
              <mat-error *ngIf="personEmail.errors?.['required']">Este campo é obrigatório</mat-error>
            </div>
          </div>

          <div class="signup-container-card--form-input">
            <label for="personPassword">Senha:</label>
            <div class="signup-container-card--form-input-show-password">
              <input [type]="hide ? 'password' : 'text'" id="personPassword" name="personPassword" [(ngModel)]="signUpPersonForm.password" #personPassword="ngModel" class="form-control" pattern=".{6,}" minlength="6" placeholder="Digite a sua senha" required>
              <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" type="button">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
            </div>
            <div class="signup-container-card--form-input-error" *ngIf="personPassword.invalid && (personPassword.dirty || personPassword.touched)">
              <mat-error *ngIf="personPassword.errors?.['required']">Este campo é obrigatório</mat-error>
              <mat-error *ngIf="personPassword.errors?.['minlength']">Este campo deve ter pelo menos 6 digitos</mat-error>
            </div>
          </div>
        </div>
      
        <button class="btn btn-primary signup-container-card--form-submit" type="submit" [disabled]="personForm.invalid">Cadastrar</button>
      </form>
    </div>
    
    <div *ngIf="showCompanyForm">
      <form class="signup-container-card--form" #companyForm="ngForm" (ngSubmit)="handleCompanyForm()">
        <div class="signup-container-card--form-input">
          <label for="ceoName">Nome do Empresário:</label>
          <input type="text" ceoName id="ceoName" name="ceoName" [(ngModel)]="signUpCompanyForm.name" #ceoName="ngModel" class="form-control" placeholder="Digite o seu nome" required>
  
          <div class="signup-container-card--form-input-error" *ngIf="ceoName.invalid && (ceoName.dirty || ceoName.touched)">
            <mat-error *ngIf="ceoName.errors?.['required']">Este campo é obrigatório</mat-error>
          </div>
        </div>

        <div class="signup-container-card--form-input-group">
          <div class="signup-container-card--form-input">
            <label for="cnpj">CNPJ:</label>
            <input type="text" cnpj id="cnpj" name="cnpj" [(ngModel)]="signUpCompanyForm.cnpj" #cnpj="ngModel" class="form-control" placeholder="Digite o seu CNPJ" mask="00.000.000/0000-00" minlength="14" required>
    
            <div class="signup-container-card--form-input-error" *ngIf="cnpj.invalid && (cnpj.dirty || cnpj.touched)">
              <mat-error *ngIf="cnpj.errors?.['required']">Este campo é obrigatório</mat-error>
              <mat-error *ngIf="cnpj.errors?.['minlength']">Este campo deve ter 14 digitos</mat-error>
            </div>
          </div>
            
          <div class="signup-container-card--form-input">
            <label for="companySocial">Razão Social:</label>
            <input type="text" companySocial id="companySocial" name="companySocial" [(ngModel)]="signUpCompanyForm.social" #companySocial="ngModel" class="form-control" placeholder="Digite a razão social" required>
    
            <div class="signup-container-card--form-input-error" *ngIf="companySocial.invalid && (companySocial.dirty || companySocial.touched)">
              <mat-error *ngIf="companySocial.errors?.['required']">Este campo é obrigatório</mat-error>
            </div>
          </div>
        </div>
        
        <div class="signup-container-card--form-input-group">
          <div class="signup-container-card--form-input">
            <label for="businessCategory">Ramo da Empresa:</label>
            <input type="text" businessCategory id="businessCategory" name="businessCategory" [(ngModel)]="signUpCompanyForm.businessCategory" #businessCategory="ngModel" class="form-control" placeholder="Digite o ramo da empresa" required>
    
            <div class="signup-container-card--form-input-error" *ngIf="businessCategory.invalid && (businessCategory.dirty || businessCategory.touched)">
              <mat-error *ngIf="businessCategory.errors?.['required']">Este campo é obrigatório</mat-error>
            </div>
          </div>

          <div class="signup-container-card--form-input">
            <label for="companyPhone">Telefone:</label>
            <input type="text" companyPhone id="companyPhone" name="companyPhone" [(ngModel)]="signUpCompanyForm.phone" #companyPhone="ngModel" class="form-control" placeholder="Digite o seu telefone" mask="(00) 00000-0000" minlength="11" required>
    
            <div class="signup-container-card--form-input-error" *ngIf="companyPhone.invalid && (companyPhone.dirty || companyPhone.touched)">
              <mat-error *ngIf="companyPhone.errors?.['required']">Este campo é obrigatório</mat-error>
              <mat-error *ngIf="companyPhone.errors?.['minlength']">Este campo deve ter 11 digitos</mat-error>
            </div>
          </div>
        </div>

        <div class="signup-container-card--form-input">
          <label for="companyAddress">Endereco:</label>
          <input type="text" companyAddress id="companyAddress" name="companyAddress" [(ngModel)]="signUpCompanyForm.address" #companyAddress="ngModel" class="form-control" placeholder="Digite o seu endereço" required>
  
          <div class="signup-container-card--form-input-error" *ngIf="companyAddress.invalid && (companyAddress.dirty || companyAddress.touched)">
            <mat-error *ngIf="companyAddress.errors?.['required']">Este campo é obrigatório</mat-error>
          </div>
        </div>

        <div class="signup-container-card--form-input-group">
          <div class="signup-container-card--form-input">
            <label for="companyState">Estado:</label>
            <input type="text" companyState id="companyState" name="companyState" [(ngModel)]="signUpCompanyForm.state" #companyState="ngModel" class="form-control" placeholder="Digite a sua cidade" required>
    
            <div class="signup-container-card--form-input-error" *ngIf="companyState.invalid && (companyState.dirty || companyState.touched)">
              <mat-error *ngIf="companyState.errors?.['required']">Este campo é obrigatório</mat-error>
            </div>
          </div>

          <div class="signup-container-card--form-input">
            <label for="companyCity">Cidade:</label>
            <input type="text" companyCity id="companyCity" name="companyCity" [(ngModel)]="signUpCompanyForm.city" #companyCity="ngModel" class="form-control" placeholder="Digite a sua cidade" required>
    
            <div class="signup-container-card--form-input-error" *ngIf="companyCity.invalid && (companyCity.dirty || companyCity.touched)">
              <mat-error *ngIf="companyCity.errors?.['required']">Este campo é obrigatório</mat-error>
            </div>
          </div>
        </div>

        <div class="signup-container-card--form-input-group">
          <div class="signup-container-card--form-input">
            <label for="companyEmail">Email:</label>
            <input type="email" companyEmail id="companyEmail" name="companyEmail" [(ngModel)]="signUpCompanyForm.email" #companyEmail="ngModel" class="form-control" placeholder="Digite o seu e-mail" required>
    
            <div class="signup-container-card--form-input-error" *ngIf="companyEmail.invalid && (companyEmail.dirty || companyEmail.touched)">
              <mat-error *ngIf="companyEmail.invalid">Digite o e-mail no formato correto</mat-error>
              <mat-error *ngIf="companyEmail.errors?.['required']">Este campo é obrigatório</mat-error>
            </div>
          </div>

          <div class="signup-container-card--form-input">
            <label for="companyPassword">Senha:</label>
            <div class="signup-container-card--form-input-show-password">
              <input [type]="hide ? 'password' : 'text'" id="companyPassword" name="companyPassword" [(ngModel)]="signUpCompanyForm.password" #companyPassword="ngModel" class="form-control" pattern=".{6,}" minlength="6" placeholder="Digite a sua senha" required>
              <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" type="button">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
            </div>
            <div class="signup-container-card--form-input-error" *ngIf="companyPassword.invalid && (companyPassword.dirty || companyPassword.touched)">
              <mat-error *ngIf="companyPassword.errors?.['required']">Este campo é obrigatório</mat-error>
              <mat-error *ngIf="companyPassword.errors?.['minlength']">Este campo deve ter pelo menos 6 digitos</mat-error>
            </div>
          </div>
        </div>
       
        <button class="btn btn-primary signup-container-card--form-submit" type="submit" [disabled]="companyForm.invalid">Cadastrar</button>
      </form>
    </div>

    <a routerLink="/login">Tem uma conta? Acesse já!</a>
  </div>
</div>
